export default "__VITE_ASSET__d45540c1__"